import * as $ from 'jquery';
import {hasClass, removeClass, addClass} from 'fire-wind-water/dom';
import {FieldEvent} from '../controllers/events/settings';

export function selectToggle() {
  $(document).off('click.form-select-hide').on('click.form-select-hide', function(ev) {
    $('.c-form-select').removeClass('open').each(function() {
      const field = FieldEvent[this.dataset.fieldName] || {};
      field.isShow = false;
    });
  });

  $(document).
    off('click.form-select-zz').
    on('click.form-select-zz', '.c-form-select, .c-form-checkbox, .select-main, .form-button', (ev) => {
      ev.stopPropagation();
    });

  $(document).off('click.select-mask').on('click.select-mask', '.select-mask', function(ev){
    $(this).parent().removeClass('open').removeClass('up');
  });
  $(document).off('click.form-select').on('click.form-select', '.select-menu', function(ev) {
    $('.c-form-select').removeClass('open').removeClass('up');
    const field = FieldEvent[this.dataset.fieldName] || {};
    if (hasClass(this.parentNode, 'open')) {
      removeClass(this.parentNode, 'open');
      field.isShow = false;
    } else {
      const h = $(this.parentNode).find('.select-main').innerHeight();
      if (document.documentElement.clientHeight - this.parentNode.getBoundingClientRect().bottom < h) {
        addClass(this.parentNode, 'open up');
        field.isUp = true;
      } else {
        addClass(this.parentNode, 'open');
        field.isUp = false;
      }
      field.isShow = true;
    }
  });
}